import moment from 'moment';

export function calculatePremiumExpiryDate(offsetDate: Date, offset: string) {
    const offsetFrom = moment(offsetDate ?? Date.now());

    switch (offset) {
        case '3d':
            offsetFrom.add(3, 'd');
            break;
        case '1w':
            offsetFrom.add(1, 'w');
            break;
        case '1m':
            offsetFrom.add(1, 'M');
            break;
        default:
            break;
    }

    return offsetFrom;
}
